export var ProcessingStrategy;
(function (ProcessingStrategy) {
    ProcessingStrategy["IMMEDIATE"] = "IMMEDIATE";
    ProcessingStrategy["DEFERRED"] = "DEFERRED";
    ProcessingStrategy["MANUAL"] = "MANUAL";
})(ProcessingStrategy || (ProcessingStrategy = {}));
